import { parseJwt } from './parseJwt';

export const tokenLanguageCode = (token) =>
  parseJwt(token)['http://schemas.finantech.pt/languageCode'];

export const tokenLanguageId = (token) =>
  parseJwt(token)['http://schemas.finantech.pt/language'];
